import React from 'react';
import Img from '../Img';
import OutboundLink from '../OutboundLink';
import {
  appStoreLink,
  playStoreLink,
} from '../../../helpers/serverRenderingUtils';
import styles from './styles.sass';

const IMG_PREFIX = 'https://d12xoj7p9moygp.cloudfront.net/images/';

export const AppleAppStoreBadge = ({ height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 135 40"
  >
    <path
      fill="#A6A6A6"
      d="M130.2 40H4.73A4.74 4.74 0 0 1 0 35.27V4.73A4.73 4.73 0 0 1 4.73 0H130.2a4.8 4.8 0 0 1 4.8 4.73v30.54a4.8 4.8 0 0 1-4.8 4.73z"
    />
    <path d="M134.03 35.27a3.83 3.83 0 0 1-3.83 3.83H4.73a3.83 3.83 0 0 1-3.84-3.83V4.72A3.84 3.84 0 0 1 4.73.9H130.2a3.83 3.83 0 0 1 3.83 3.84v30.54z" />
    <path
      d="M30.13 19.78a5.79 5.79 0 0 1 2.76-4.86 5.94 5.94 0 0 0-4.68-2.53c-1.96-.2-3.87 1.18-4.87 1.18-1.03 0-2.57-1.16-4.23-1.12a6.23 6.23 0 0 0-5.24 3.2c-2.27 3.91-.58 9.68 1.6 12.85 1.08 1.55 2.35 3.29 4 3.23 1.63-.07 2.24-1.04 4.2-1.04 1.95 0 2.52 1.04 4.2 1 1.75-.03 2.85-1.56 3.9-3.13a12.83 12.83 0 0 0 1.78-3.62 5.6 5.6 0 0 1-3.42-5.16zm-3.2-9.48a5.7 5.7 0 0 0 1.3-4.08 5.81 5.81 0 0 0-3.75 1.94 5.43 5.43 0 0 0-1.34 3.94 4.8 4.8 0 0 0 3.79-1.8zm26.72 21.2h-2.28l-1.24-3.9h-4.32l-1.19 3.9h-2.21l4.28-13.3h2.65l4.3 13.3zm-3.9-5.55l-1.12-3.47c-.12-.35-.34-1.2-.67-2.5h-.04c-.13.56-.34 1.4-.63 2.5l-1.1 3.48h3.57zm14.91.64c0 1.63-.44 2.92-1.32 3.87a3.87 3.87 0 0 1-2.94 1.26c-1.27 0-2.17-.45-2.73-1.36h-.04v5.05H55.5V25.07c0-1.03-.03-2.08-.08-3.16h1.88l.12 1.52h.04a3.55 3.55 0 0 1 3.23-1.72c1.14 0 2.08.45 2.84 1.34.75.9 1.13 2.08 1.13 3.54zm-2.17.08c0-.94-.21-1.7-.63-2.31A2.18 2.18 0 0 0 60 23.4c-.52 0-1 .17-1.43.52-.43.35-.7.8-.84 1.37-.06.27-.1.48-.1.65v1.6c0 .7.22 1.3.65 1.77s.98.72 1.66.72c.8 0 1.43-.3 1.88-.92.45-.62.67-1.44.67-2.45zm13.21-.08c0 1.63-.44 2.92-1.33 3.87a3.86 3.86 0 0 1-2.94 1.26c-1.26 0-2.17-.45-2.72-1.36h-.04v5.05h-2.13V25.07c0-1.03-.03-2.08-.08-3.16h1.87l.12 1.52h.04a3.55 3.55 0 0 1 3.24-1.72 3.6 3.6 0 0 1 2.84 1.34 5.3 5.3 0 0 1 1.13 3.54zm-2.17.08c0-.94-.21-1.7-.64-2.31a2.18 2.18 0 0 0-1.85-.95 2.4 2.4 0 0 0-2.27 1.89c-.07.27-.1.48-.1.65v1.6c0 .7.21 1.3.64 1.77.43.48.98.72 1.67.72.8 0 1.43-.3 1.88-.92.44-.62.67-1.44.67-2.45zm14.51 1.1a3.6 3.6 0 0 1-1.18 2.77 5.24 5.24 0 0 1-3.63 1.16 6.35 6.35 0 0 1-3.45-.83l.5-1.78c.93.57 1.96.85 3.08.85.8 0 1.43-.18 1.88-.54.44-.36.67-.85.67-1.45 0-.54-.19-1-.56-1.37a5.14 5.14 0 0 0-1.83-1.03c-2.33-.87-3.5-2.14-3.5-3.81 0-1.1.41-2 1.23-2.7A4.87 4.87 0 0 1 84.51 18c1.2 0 2.21.21 3.02.63l-.54 1.74c-.75-.4-1.6-.61-2.54-.61-.75 0-1.34.18-1.76.55-.36.33-.53.73-.53 1.2 0 .53.2.97.6 1.31.36.32 1 .66 1.94 1.03a6.5 6.5 0 0 1 2.53 1.62c.54.61.8 1.38.8 2.3zm7.05-4.27h-2.35v4.67c0 1.18.41 1.77 1.24 1.77.38 0 .7-.03.95-.1l.06 1.62c-.42.16-.97.24-1.66.24a2.6 2.6 0 0 1-1.98-.77c-.47-.51-.7-1.38-.7-2.59v-4.83h-1.4v-1.6h1.4v-1.76l2.09-.63v2.39h2.35v1.6zm10.61 3.13c0 1.47-.43 2.68-1.27 3.63a4.51 4.51 0 0 1-3.52 1.46c-1.4 0-2.53-.47-3.36-1.4s-1.26-2.11-1.26-3.53c0-1.5.43-2.7 1.3-3.66a4.47 4.47 0 0 1 3.48-1.42c1.4 0 2.54.47 3.4 1.4a5.1 5.1 0 0 1 1.22 3.52zm-2.22.07c0-.89-.19-1.65-.57-2.28a2.1 2.1 0 0 0-1.92-1.15c-.85 0-1.5.38-1.95 1.15a4.4 4.4 0 0 0-.57 2.32c0 .88.18 1.64.57 2.27.46.77 1.1 1.15 1.93 1.15.82 0 1.46-.39 1.92-1.17.4-.64.59-1.41.59-2.3zm9.14-2.92a3.7 3.7 0 0 0-.67-.06c-.75 0-1.33.29-1.74.85a3.2 3.2 0 0 0-.53 1.9v5.03h-2.13l.02-6.57c0-1.1-.03-2.11-.08-3.02h1.85l.08 1.83h.06c.23-.63.58-1.13 1.07-1.52.47-.34.98-.5 1.54-.5.2 0 .37 0 .53.03v2.03zm9.54 2.47a5 5 0 0 1-.08.97h-6.4c.03.95.34 1.67.93 2.17.54.45 1.24.67 2.1.67.94 0 1.8-.15 2.58-.45l.33 1.48a8 8 0 0 1-3.21.6 4.66 4.66 0 0 1-3.5-1.32 4.85 4.85 0 0 1-1.28-3.53c0-1.44.4-2.65 1.18-3.6a4.09 4.09 0 0 1 3.36-1.55 3.6 3.6 0 0 1 3.14 1.54c.56.82.85 1.82.85 3.02zm-2.04-.55a2.9 2.9 0 0 0-.41-1.64c-.37-.6-.94-.89-1.7-.89-.7 0-1.26.29-1.7.87a3.18 3.18 0 0 0-.63 1.66h4.44zM49.05 10c0 1.19-.35 2.07-1.06 2.67a4.2 4.2 0 0 1-2.78.82c-.6 0-1.1-.03-1.53-.08V6.98a11.2 11.2 0 0 1 1.8-.13c1.15 0 2 .25 2.6.74.64.57.97 1.37.97 2.42zm-1.1.04c0-.76-.2-1.35-.61-1.76-.4-.4-1-.6-1.77-.6-.33 0-.61.01-.85.06v4.89c.13.02.37.03.71.03.8 0 1.42-.23 1.86-.67s.66-1.1.66-1.95zm6.95 1c0 .72-.2 1.32-.61 1.78-.44.48-1.01.72-1.73.72a2.1 2.1 0 0 1-1.65-.69 2.5 2.5 0 0 1-.62-1.73c0-.73.21-1.33.64-1.8s1-.7 1.7-.7 1.26.23 1.68.7c.4.44.6 1.01.6 1.72zm-1.08.03c0-.43-.1-.8-.28-1.12a1.03 1.03 0 0 0-.94-.56c-.42 0-.74.19-.96.56-.19.31-.28.7-.28 1.14 0 .43.1.8.28 1.12.23.37.54.56.95.56.4 0 .72-.19.94-.57.2-.32.3-.7.3-1.13zm8.95-2.35l-1.48 4.71h-.96l-.61-2.04c-.16-.52-.28-1.02-.38-1.53h-.02a11.4 11.4 0 0 1-.38 1.53l-.65 2.04h-.97l-1.38-4.71H57l.54 2.24c.12.53.23 1.03.32 1.51h.01c.08-.4.21-.9.4-1.5l.66-2.25h.86l.64 2.2c.15.54.28 1.06.38 1.55h.02c.08-.48.18-1 .32-1.55l.58-2.2h1.02zm5.43 4.71h-1.05v-2.7c0-.83-.32-1.24-.95-1.24a.95.95 0 0 0-.76.34c-.19.23-.29.5-.29.8v2.8H64.1v-3.36c0-.42 0-.87-.03-1.35h.92l.05.73h.03a1.73 1.73 0 0 1 1.49-.83c.44 0 .8.14 1.1.43.36.35.54.87.54 1.56v2.82zm2.89 0h-1.05V6.56h1.05v6.87zm6.17-2.39c0 .72-.2 1.32-.62 1.78-.44.48-1.01.72-1.73.72a2.1 2.1 0 0 1-1.65-.69 2.5 2.5 0 0 1-.62-1.73c0-.73.21-1.33.64-1.8s.99-.7 1.7-.7c.7 0 1.26.23 1.68.7.4.44.6 1.01.6 1.72zm-1.09.03c0-.43-.1-.8-.28-1.12a1.03 1.03 0 0 0-.94-.56c-.42 0-.74.19-.96.56-.19.31-.28.7-.28 1.14 0 .43.1.8.28 1.12.23.37.54.56.95.56.4 0 .71-.19.94-.57.2-.32.29-.7.29-1.13zm6.16 2.36h-.94l-.08-.54h-.03c-.32.43-.78.65-1.38.65-.44 0-.8-.14-1.07-.43a1.34 1.34 0 0 1-.37-.96c0-.57.24-1.01.72-1.32a3.8 3.8 0 0 1 2.04-.44v-.09c0-.62-.33-.93-.98-.93-.47 0-.88.12-1.23.35l-.21-.69c.43-.27.97-.4 1.61-.4 1.23 0 1.85.64 1.85 1.94v1.74c0 .47.02.84.07 1.12zm-1.09-1.62v-.72c-1.15-.02-1.73.3-1.73.95 0 .24.06.43.2.55.13.12.3.18.51.18.23 0 .45-.07.64-.21a.9.9 0 0 0 .38-.75zm7.04 1.62h-.93l-.04-.75h-.03c-.3.57-.8.86-1.52.86-.57 0-1.04-.22-1.41-.67s-.57-1.02-.57-1.73c0-.77.2-1.39.62-1.86.4-.44.87-.66 1.45-.66.63 0 1.08.22 1.33.64h.02v-2.7h1.05v5.6c0 .46.01.88.03 1.27zm-1.08-1.98v-.8a1.2 1.2 0 0 0-.4-.96c-.2-.17-.44-.25-.71-.25-.4 0-.7.15-.92.46a2 2 0 0 0-.34 1.2c0 .46.1.84.32 1.13.23.31.54.47.92.47a1 1 0 0 0 .83-.4c.2-.23.3-.52.3-.86zm10.05-.41c0 .72-.2 1.32-.62 1.78-.44.48-1.01.72-1.73.72-.7 0-1.24-.23-1.65-.69a2.5 2.5 0 0 1-.62-1.73c0-.73.21-1.33.64-1.8s.99-.7 1.7-.7c.7 0 1.26.23 1.68.7.4.44.6 1.01.6 1.72zm-1.09.03c0-.43-.1-.8-.28-1.12a1.04 1.04 0 0 0-.94-.56c-.42 0-.74.19-.96.56-.19.31-.28.7-.28 1.14 0 .43.1.8.28 1.12.23.37.54.56.95.56.4 0 .71-.19.94-.57.2-.32.3-.7.3-1.13zm6.72 2.36h-1.04v-2.7c0-.83-.32-1.24-.96-1.24-.3 0-.56.1-.75.34s-.3.5-.3.8v2.8H98.8v-3.36c0-.42-.01-.87-.04-1.35h.92l.05.73h.03c.12-.22.3-.41.54-.56.29-.18.6-.27.95-.27.44 0 .8.14 1.1.43.36.35.54.87.54 1.56v2.82zm7.06-3.93h-1.16v2.3c0 .58.2.87.61.87.2 0 .35-.02.47-.05l.03.8c-.21.07-.48.11-.82.11-.41 0-.73-.13-.97-.38-.23-.25-.35-.67-.35-1.27V9.5h-.68v-.78h.68v-.87l1.03-.3v1.17h1.16v.78zm5.54 3.93h-1.05v-2.68c0-.84-.31-1.26-.94-1.26-.49 0-.82.24-1 .73-.04.1-.05.23-.05.38v2.83h-1.05V6.56h1.05V9.4h.02c.33-.52.8-.78 1.41-.78.44 0 .8.14 1.08.43.36.35.53.88.53 1.58v2.8zm5.72-2.58c0 .2 0 .35-.03.48h-3.15c.02.46.17.82.46 1.06.27.22.6.33 1.03.33.46 0 .89-.07 1.27-.22l.16.73c-.44.2-.97.3-1.58.3a2.3 2.3 0 0 1-1.72-.65 2.38 2.38 0 0 1-.62-1.74c0-.7.19-1.3.58-1.77a2 2 0 0 1 1.65-.76c.67 0 1.19.26 1.54.76.28.4.42.9.42 1.48zm-1-.27c.01-.3-.05-.58-.2-.8a.92.92 0 0 0-.83-.44 1 1 0 0 0-.83.43c-.18.22-.28.5-.32.81h2.19z"
      fill="#FFF"
    />
  </svg>
);

// Only width is given so that
export const GooglePlayBadge = ({ height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="10 10 135 40"
    height={height}
    width={width}
  >
    <defs>
      <linearGradient
        id="gpb_a"
        x1="31.8"
        y1="183.29"
        x2="15.02"
        y2="166.51"
        gradientTransform="matrix(1 0 0 -1 0 202)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#00a0ff" />
        <stop offset=".01" stopColor="#00a1ff" />
        <stop offset=".26" stopColor="#00beff" />
        <stop offset=".51" stopColor="#00d2ff" />
        <stop offset=".76" stopColor="#00dfff" />
        <stop offset="1" stopColor="#00e3ff" />
      </linearGradient>
      <linearGradient
        id="gpb_b"
        x1="43.83"
        y1="172"
        x2="19.64"
        y2="172"
        gradientTransform="matrix(1 0 0 -1 0 202)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ffe000" />
        <stop offset=".41" stopColor="#ffbd00" />
        <stop offset=".78" stopColor="orange" />
        <stop offset="1" stopColor="#ff9c00" />
      </linearGradient>
      <linearGradient
        id="gpb_c"
        x1="34.83"
        y1="169.7"
        x2="12.07"
        y2="146.95"
        gradientTransform="matrix(1 0 0 -1 0 202)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#ff3a44" />
        <stop offset="1" stopColor="#c31162" />
      </linearGradient>
      <linearGradient
        id="gpb_d"
        x1="17.3"
        y1="191.82"
        x2="27.46"
        y2="181.66"
        gradientTransform="matrix(1 0 0 -1 0 202)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#32a071" />
        <stop offset=".07" stopColor="#2da771" />
        <stop offset=".48" stopColor="#15cf74" />
        <stop offset=".8" stopColor="#06e775" />
        <stop offset="1" stopColor="#00f076" />
      </linearGradient>
    </defs>
    <rect x="10" y="10" width="135" height="40" rx="5" ry="5" />
    {/* Border */}
    <path
      d="M140 10.8a4.2 4.2 0 0 1 4.2 4.2v30a4.2 4.2 0 0 1-4.2 4.2H15a4.2 4.2 0 0 1-4.2-4.2V15a4.2 4.2 0 0 1 4.2-4.2h125m0-.8H15a5 5 0 0 0-5 5v30a5 5 0 0 0 5 5h125a5 5 0 0 0 5-5V15a5 5 0 0 0-5-5z"
      fill="#a6a6a6"
    />
    {/* Content */}
    <path
      d="M57.42 20.24a2.71 2.71 0 0 1-.75 2 2.91 2.91 0 0 1-2.2.89 3.15 3.15 0 0 1-2.21-5.37 3 3 0 0 1 2.21-.9 3.1 3.1 0 0 1 1.23.25 2.47 2.47 0 0 1 .94.67l-.53.53a2 2 0 0 0-1.64-.71 2.32 2.32 0 0 0-2.33 2.4 2.36 2.36 0 0 0 4 1.73 1.89 1.89 0 0 0 .5-1.22h-2.17v-.72h2.91a2.54 2.54 0 0 1 .04.45zM62 17.74h-2.7v1.9h2.46v.72H59.3v1.9H62V23h-3.5v-6H62zM65.28 23h-.77v-5.26h-1.68V17H67v.74h-1.72zM69.94 23v-6h.77v6zM74.13 23h-.77v-5.26h-1.68V17h4.12v.74h-1.67zM83.61 22.22a3.12 3.12 0 0 1-4.4 0 3.24 3.24 0 0 1 0-4.45 3.1 3.1 0 0 1 4.4 0 3.23 3.23 0 0 1 0 4.45zm-3.83-.5a2.31 2.31 0 0 0 3.26 0 2.56 2.56 0 0 0 0-3.44 2.31 2.31 0 0 0-3.26 0 2.56 2.56 0 0 0 0 3.44zM85.58 23v-6h.94l2.92 4.67V17h.77v6h-.8l-3.05-4.89V23z"
      fill="#fff"
      stroke="#fff"
      strokeMiterlimit="10"
      strokeWidth=".2"
    />
    <path
      d="M78.14 31.75A4.25 4.25 0 1 0 82.41 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-9.31-6.83A4.25 4.25 0 1 0 73.09 36a4.19 4.19 0 0 0-4.27-4.25zm0 6.83A2.58 2.58 0 1 1 71.22 36a2.46 2.46 0 0 1-2.4 2.58zm-11.09-5.52v1.8h4.32a3.77 3.77 0 0 1-1 2.27 4.42 4.42 0 0 1-3.33 1.32 4.8 4.8 0 0 1 0-9.6A4.6 4.6 0 0 1 61 30.14l1.27-1.27A6.29 6.29 0 0 0 57.74 27a6.61 6.61 0 1 0 0 13.21 6 6 0 0 0 4.61-1.85 6 6 0 0 0 1.56-4.22 5.87 5.87 0 0 0-.1-1.13zm45.31 1.4a4 4 0 0 0-3.64-2.71 4 4 0 0 0-4 4.25 4.16 4.16 0 0 0 4.22 4.25 4.23 4.23 0 0 0 3.54-1.88l-1.45-1a2.43 2.43 0 0 1-2.09 1.18 2.16 2.16 0 0 1-2.06-1.29l5.69-2.35zm-5.8 1.42a2.33 2.33 0 0 1 2.22-2.48 1.65 1.65 0 0 1 1.58.9zM92.63 40h1.87V27.5h-1.87zm-3.06-7.3h-.07a3 3 0 0 0-2.24-1 4.26 4.26 0 0 0 0 8.51 2.9 2.9 0 0 0 2.24-1h.06v.61c0 1.63-.87 2.5-2.27 2.5a2.35 2.35 0 0 1-2.14-1.51l-1.63.68A4.05 4.05 0 0 0 87.29 44c2.19 0 4-1.29 4-4.43V32h-1.72zm-2.14 5.88a2.59 2.59 0 0 1 0-5.16A2.4 2.4 0 0 1 89.7 36a2.38 2.38 0 0 1-2.28 2.58zm24.38-11.08h-4.47V40h1.87v-4.74h2.61a3.89 3.89 0 1 0 0-7.76zm0 6h-2.61v-4.26h2.65a2.14 2.14 0 1 1 0 4.29zm11.53-1.8a3.5 3.5 0 0 0-3.33 1.91l1.66.69a1.77 1.77 0 0 1 1.7-.92 1.8 1.8 0 0 1 2 1.61v.13a4.13 4.13 0 0 0-1.95-.48c-1.79 0-3.6 1-3.6 2.81a2.89 2.89 0 0 0 3.1 2.75 2.63 2.63 0 0 0 2.4-1.2h.06v1h1.8v-4.81c0-2.19-1.66-3.46-3.79-3.46zm-.23 6.85c-.61 0-1.46-.31-1.46-1.06 0-1 1.06-1.33 2-1.33a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1-2.19 2zM133.74 32l-2.14 5.42h-.06L129.32 32h-2l3.33 7.58-1.9 4.21h1.95L135.82 32zm-16.81 8h1.87V27.5h-1.87z"
      fill="#fff"
    />
    <path
      d="M20.44 17.54a2 2 0 0 0-.46 1.4v22.12a2 2 0 0 0 .46 1.4l.07.07L32.9 30.15v-.29L20.51 17.47z"
      fill="url(#gpb_a)"
    />
    <path
      d="M37 34.28l-4.1-4.13v-.29l4.1-4.14.09.05L42 28.56c1.4.79 1.4 2.09 0 2.89l-4.89 2.78z"
      fill="url(#gpb_b)"
    />
    <path
      d="M37.12 34.22L32.9 30 20.44 42.46a1.63 1.63 0 0 0 2.08.06l14.61-8.3"
      fill="url(#gpb_c)"
    />
    <path
      d="M37.12 25.78l-14.61-8.3a1.63 1.63 0 0 0-2.08.06L32.9 30z"
      fill="url(#gpb_d)"
    />
    <path
      className={styles.isolate}
      d="M37 34.13l-14.49 8.25a1.67 1.67 0 0 1-2 0l-.07.07.07.07a1.66 1.66 0 0 0 2 0l14.61-8.3z"
      opacity=".2"
    />
    <path
      className={styles.isolate}
      d="M20.44 42.32a2 2 0 0 1-.46-1.4v.15a2 2 0 0 0 .46 1.4l.07-.07zM42 31.3l-5 2.83.09.09L42 31.44A1.75 1.75 0 0 0 43 30a1.86 1.86 0 0 1-1 1.3z"
      opacity=".12"
    />
    <path
      className={styles.isolate}
      d="M22.51 17.62L42 28.7a1.86 1.86 0 0 1 1 1.3 1.75 1.75 0 0 0-1-1.44L22.51 17.48c-1.4-.79-2.54-.13-2.54 1.47v.15c.03-1.61 1.15-2.27 2.54-1.48z"
      fill="#fff"
      opacity=".25"
    />
  </svg>
);

// DEFAULT to matching HEIGHT on the icons
// if WIDTH ever needs to match, use WIDTH instead

// withShadow is not guaranteed due to border radius being unknown (defaults to 10px)
// control shadow from className or parent
// TODO: control shadow from svg
export const PlayStoreButton = ({
  campaign = null,
  className = '',
  height = undefined,
  newWindow = false,
  to = null,
  width = 115,
  withShadow = false,
}) => (
  <OutboundLink
    className={`${styles.appLink} ${
      withShadow ? styles.googlePlayWithShadow : ''
    } ${className}`}
    newWindow={newWindow}
    to={to || playStoreLink({ campaign })}
  >
    <GooglePlayBadge height={height} width={height ? undefined : width} />
  </OutboundLink>
);

export const AppStoreButton = ({
  campaign = null,
  className = '',
  height = undefined,
  newWindow = false,
  to = null,
  width = 115,
  withShadow = false,
}) => (
  <OutboundLink
    className={`${styles.appLink} ${
      withShadow ? styles.appStoreWithShadow : ''
    } ${className}`}
    newWindow={newWindow}
    to={to || appStoreLink(campaign)}
  >
    <AppleAppStoreBadge height={height} width={height ? undefined : width} />
  </OutboundLink>
);

// export const AppStoreButton = ({
//   withShadow = false,
//   width = 119.664,
//   height = 40,
//   className = '',
//   layout = "fixed",
// }) => (
//   <a href={appStoreLink()} className={className || undefined}>
//   </a>
// );
